import apiClient from '../index';

export const getAllPermissions = async () => {
  try {
    const response = await apiClient.get('/api/permissions/');
    return response.data;
  } catch (error) {
    console.error(`Error on fetching permissions`, error);
    throw error;
  }
};
